// extracted by mini-css-extract-plugin
export var button = "ProductList-module--button--P9+SP";
export var roseTheme = "ProductList-module--roseTheme--0OrRT";
export var text = "ProductList-module--text--0sMkH";
export var title = "ProductList-module--title--aK7Kh";
export var wrapper = "ProductList-module--wrapper--JvScV";